import {
  EdfMatches,
  EdfTeams,
  EdfOpponents,
  DirectusFiles,
  EdfArenas,
  EdfCities,
  EdfCountries,
} from '../directus';
import { CardCalendarInfo, DateLabelType } from '@/components/types';
import { AppConfig } from '@/utils/AppConfig';
import getDirectusImageUrl from '../utils/image';
import fetcher from '@/lib/utils/fetcherBasic';
import { LiveData } from '@/lib/repositories';

const getDataLive = async () => {
  const live = await fetcher<Array<LiveData>>(`/api/live`, {
    cache: 'no-store',
  });

  return {
    live,
  };
};

export default async function mapCampaignToScoreCards(
  data: Array<EdfMatches>,
): Promise<Array<CardCalendarInfo>> {
  const lives = await getDataLive();

  let currentlives = [] as Array<string>;

  if (lives?.live && Array.isArray(lives.live)) {
    currentlives = ((lives?.live || []) as Array<LiveData>)
      .filter((live) => live.matchStatus === 'IN_PROGRESS')
      .map((live) => live.matchId);
  }
  return data.map(
    ({
      arena,
      city,
      country,
      date,
      hour,
      edf_team,
      france_at_home,
      phase,
      preparation,
      opponent,
      gsId,
      score_france,
      score_opponent,
      score_france_q1 = -1,
      score_france_q2 = -1,
      score_france_q3 = -1,
      score_france_q4 = -1,
      score_france_ot1 = -1,
      score_france_ot2 = -1,
      score_opponent_q1 = -1,
      score_opponent_q2 = -1,
      score_opponent_q3 = -1,
      score_opponent_q4 = -1,
      score_opponent_ot1 = -1,
      score_opponent_ot2 = -1,
      url_ticketing,
      url_match_sheet,
    }) => {
      const edfTeam = edf_team as EdfTeams;
      const opponentTeam = opponent as EdfOpponents;
      let place = (arena as EdfArenas)?.name || '';
      const cityLabel = (city as EdfCities)?.name || '';
      const countryLabel = (country as EdfCountries)?.name || '';

      if (cityLabel && countryLabel) {
        place = `${(city as EdfCities)?.name} - ${(country as EdfCountries)?.name}`;
      }

      const dateMatch = date ? `${date}T${hour || '00:00:00'}.000` : '';
      let dateLabelType: DateLabelType = hour && hour !== '00:00:00' ? 'live' : 'default';

      const team1Name = france_at_home ? 'FRANCE' : opponentTeam?.name;
      const team2Name = france_at_home ? opponentTeam?.name : 'FRANCE';
      const team1Score = france_at_home ? score_france : score_opponent;
      const team2Score = france_at_home ? score_opponent : score_france;
      const team1Logo = france_at_home ? edfTeam.logo : opponentTeam?.logo;
      const team2Logo = france_at_home ? opponentTeam?.logo : edfTeam.logo;

      const franceAtHomeQuarterScores = [
        [score_france_q1, score_opponent_q1],
        [score_france_q2, score_opponent_q2],
        [score_france_q3, score_opponent_q3],
        [score_france_q4, score_opponent_q4],
      ] as Array<[number, number]>;

      const opponentAtHomeQuarterScores = [
        [score_opponent_q1, score_france_q1],
        [score_opponent_q2, score_france_q2],
        [score_opponent_q3, score_france_q3],
        [score_opponent_q4, score_france_q4],
      ] as Array<[number, number]>;

      if (
        score_france_ot1 &&
        score_france_ot1 !== -1 &&
        score_opponent_ot1 &&
        score_opponent_ot1 !== -1
      ) {
        franceAtHomeQuarterScores.push([score_france_ot1, score_opponent_ot1]);
        opponentAtHomeQuarterScores.push([score_opponent_ot1, score_france_ot1]);
      }

      if (
        score_france_ot2 &&
        score_france_ot2 !== -1 &&
        score_opponent_ot2 &&
        score_opponent_ot2 !== -1
      ) {
        franceAtHomeQuarterScores.push([score_france_ot2, score_opponent_ot2]);
        opponentAtHomeQuarterScores.push([score_opponent_ot2, score_france_ot2]);
      }

      let quarterScores = france_at_home ? franceAtHomeQuarterScores : opponentAtHomeQuarterScores;

      if (quarterScores.length && quarterScores[0][0] === null) {
        quarterScores = [];
      }

      let url = gsId ? `${AppConfig.geniusSportsBaseUrl}/${gsId}` : '';
      if (url_ticketing && date && new Date(date).toISOString() > new Date().toISOString()) {
        url = url_ticketing;
      }
      if (url_match_sheet) {
        url = url_match_sheet;
      }
      if (gsId && currentlives.includes(gsId.toString())) {
        url = `${AppConfig.geniusSportsBaseUrl}/${gsId}`;
      }
      return {
        isoDate: dateMatch,
        dateLabelType,
        title: '',
        callToActionUrl: {
          url: url,
          external: true,
        },
        gsId: gsId || null,
        image: '',
        place,
        team1: {
          name: team1Name || '',
          score: team1Score || 0,
          logo: team1Logo ? getDirectusImageUrl((team1Logo as DirectusFiles)?.id, true, 64) : '',
        },
        team2: {
          name: team2Name || '',
          score: team2Score || 0,
          logo: team2Logo ? getDirectusImageUrl((team2Logo as DirectusFiles)?.id, true, 64) : '',
        },
        quarterScores,
        phase,
        preparation,
      };
    },
  );
}
